import React from 'react';
import Loading from 'components/pure/utils/Loading';
import InfiniteScroll from 'react-infinite-scroller';
import MailTableRow from './MailTableRow';
import './MailTable.styl';
import GenericLink from 'components/GenericLink';

/* Be careful with this guy.  Re-renders while near the bottom
   of the page can cause the infinite scroller to repeatedly fire
   the loadMore callback.  Don't bring in props that aren't needed
   as they may cause unnecessary re-renders
   */
export default class MailTable extends React.PureComponent {
  render() {
    const filtersIsSet = this.props.filters && this.props.filters.isSet();
    const {items: mail, page = 0, numPages} = this.props.mailResults || {};

    return (
      <div className="mail-table">
        {this.props.wasError ? (
          <div className="ev-error-message">
            <p>There was an error loading the mail items. </p>
            <GenericLink onClick={() => this.props.loadMore()}>Click to try again.</GenericLink>
          </div>
        ) : !mail ? (
          <div className="loading-wrapper">
            <Loading />
          </div>
        ) : (
          <div
            className={
              mail.size === 0 && !filtersIsSet
                ? 'centered-infinite-scroll-wrapper'
                : 'infinite-scroll-wrapper'
            }>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => this.props.loadMore()}
              initialLoad={false}
              hasMore={numPages === undefined || numPages > page + 1}
              getScrollParent={() => document.getElementById('app-child-content')}
              useWindow={false}
              loader={<Loading key={0} />}>
              {mail.size === 0 ? (
                filtersIsSet ? (
                  <div className="no-results-wrapper">
                    <div className="no-results">Nothing found matching your criteria</div>
                  </div>
                ) : (
                  <div className="no-results-wrapper">
                    <div className="no-results">You're all done!</div>
                  </div>
                )
              ) : (
                mail.map(itemId => (
                  <MailTableRow
                    key={itemId}
                    item={this.props.mail.get(itemId)}
                    // reverseSelectedMail XOR areAllSelected
                    isSelected={
                      this.props.reverseSelectedMail.get(itemId)
                        ? !this.props.areAllSelected
                        : this.props.areAllSelected
                    }
                    filters={this.props.filters}
                  />
                ))
              )}
            </InfiniteScroll>
          </div>
        )}
      </div>
    );
  }
}
